export default __webpack_public_path__ + "static/media/blue-check.7bf7c5ef.svg";